import { Auth } from 'aws-amplify';
import axios from 'axios';

/**
 * Fetches an organization's volunteer invite URL. The link is an HMAC signed with a server-side
 * secret, so it cannot be built here -- the manager has to be handed it.
 *
 * The organization is in the path rather than the x-selected-organization header because the
 * mobile app's API client does not send that header, and the backend authorises off the
 * organization named here. Sent anyway, since the rest of this app does.
 */
export const fetchOrganizationInviteLink = async (organizationId) => {
  const apiUrl = process.env.REACT_APP_VOLUNTEER_INVITE_API_URL;
  if (!apiUrl) {
    throw new Error('Volunteer invite API URL not configured');
  }

  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();

  const response = await axios.get(`${apiUrl}/organizations/${organizationId}/invite-link`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'x-selected-organization': localStorage.getItem('organization-context'),
    },
  });

  return response.data;
};
